import { Component, OnInit } from '@angular/core';
import { ApiRequestService } from '../../../_services/api-request.service';
import { MaterializeAction } from 'angular2-materialize';
import { Router } from "@angular/router";
import * as _ from 'lodash';

declare var $: any;
declare var Materialize: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  loading = 0;

  list_data: any;
  body_parts: any;
  details_list = [];
  treatments_list = [];
  DecisionList = ['uphold', 'overturn', 'all'];


  Decision = "Choose Your Option";
  bodypart_name = "";

  selectedItems_details_list = [];
  dropdownSettings_details_list = {};

  selectedItems_treatments_list = [];
  dropdownSettings_treatments_list = {};


  start_dt: any = "Choose Your Option";
  end_dt: any = "Choose Your Option";

  radiolabel = true;
  radio_Option = 'caseno';

  Cases = "Choose Your Option";

  result_loader = false;

  Treatment = '';
  static Treatment;

  constructor(private apirequest: ApiRequestService, private router: Router) { }

  ngOnInit() {
    this.dropdownSettings_treatments_list = {
      singleSelection: false,
      text: "Select Treatments List",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      limitSelection: 8,
      classes: "multi-select",
    };
    this.dropdownSettings_details_list = {
      singleSelection: false,
      text: "Select Details List",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: false,
      classes: "multi-select",
    };
    this.get_list();
    setTimeout(() => {
      this.md_call();
    }, 10);
  }

  md_call(){
    $(document).ready(function() {
      Materialize.updateTextFields();
    });
  }


  get_list() {
    this.loading = 1;
    let data = { action: "get_list" };
    this.apirequest.customize_flow(data).subscribe(res => {
      console.log(res);
      if (res.status == "True") {
        this.loading = 0;
        this.list_data = res.msg;
        this.body_parts = this.list_data.body_parts;
        this.generate_details_list(this.list_data.details_list);
        // this.generate_treatments_list(this.list_data.treatments);
        console.log(this.details_list);

      } else {
        this.msg_view(res.msg);
        this.loading = 0;
      }
    });
  }

  msg_view(msg_data) {
    $(document).ready(function () {
      Materialize.toast(msg_data.toString(), 3000, 'grey darken-4');
    });
  }

  get_bodypart_name(item) {
    this.bodypart_name = item;
    // setTimeout(() => {
    //   this.generate_treatments_list(this.list_data.treatments);   
    // }, 10);
   
  }

  generate_details_list(item: any) {
    let i = 1;
    item.map((x) => this.details_list.push({ id: i++, itemName: x }));
    // console.log(this.dropdownList);
  }

  generate_treatments_list(item: any) {
    // let i = 1;
    // item.map((x) => this.treatments_list.push({ id: i++, itemName: x }));
    // console.log(this.dropdownList);
    this.load_data(item);
  }

  load_data(data){
    let name = {};
    console.log(data);
    
   

    for (var i = 0; i < data.length; i++) {
      name[data[i]] = null;
    }
    console.log(name);
    

    $('input.autocompleteTreatment').autocomplete({
      data: name,
      limit: 10, 
      onAutocomplete: function(val) {
        console.log(val); 
        DashboardComponent.Treatment = val;       
      },
      minLength: 1,
    });
  }

  onSearchChange(searchValue: string,label) {
    console.log(searchValue);
    console.log(this.Treatment);
    
  }

  onItemSelect_details_list(item: any) {
    console.log(item);

  }

  OnItemDeSelect_details_list(item: any) {
    console.log(item);

  }

  onSelectAll_details_list(items: any) {
    console.log(items);

  }

  onDeSelectAll_details_list(items: any) {
    console.log(items);
  }

  Calender_init() {
    $("input[class*='datepicker-']").pickadate({
      selectMonths: true,
      selectYears: true,
      min: new Date(1997, 3, 20),
      max: new Date(2022, 1, 31),
      format: 'yyyy-mm-dd',
      onSet: function (obj) {
        console.log(obj);
        let thisPicker = $(this)[0].$node;    // Needed to hack to get the thing I was after.

        // Check if this is the start date
        let classes = thisPicker.attr("class");
        if (classes === undefined || classes.length === 0 || classes.indexOf("datepicker-start") < 0) {
          return;
        }

        // .datepicker-start must be wrapped in a div.input-field element (in this example), and
        // .datepicker-end must be in the next div.input-field.  Change selectors for your conditions.
        let parent1 = thisPicker.closest("div.input-field");    // This picker's parent
        let parent2 = parent1.next("div.input-field");          // Next picker's parent
        let picker2 = parent2.find(".datepicker-end");          // Matching 'end' picker

        // Set end picker minimum date, or whatever you need.
        if (obj.select) {
          let dt = new Date(obj.select)
          console.log(dt);

          picker2.pickadate('picker').set('min', dt);
        }

        if (obj.hasOwnProperty('clear')) {
          picker2.pickadate('picker').set('min', false);
        }

      },
      onClose: function () {
        $(document.activeElement).blur();
        localStorage.setItem("start", $('#start1').val());
        localStorage.setItem("end", $('#end1').val());
        console.log($('#start1').val());
        console.log($('#end1').val());
      }
    });

    $('.datepicker-start').on('mousedown', function preventClosing(event) {
      event.preventDefault();
    });

    $('.datepicker-end').on('mousedown', function preventClosing(event) {
      event.preventDefault();
    });
  }

  radio_check(item) {
    this.radio_Option = item;
    console.log(this.radio_Option);
    if (this.radio_Option == 'casedate') {
      setTimeout(() => {
        this.Calender_init();
      }, 0.1);
    }

  }

  setCaseValues() {
    this.start_dt = '';
    this.end_dt = '';
  }

  check_values(id) {
    if (id === 'start') {
      this.Cases = "Choose Your Options";
      console.log("click");
      this.end_dt = "Choose Your Option";
      $('#end1').val('');
      let interval = setInterval(() => {
        let response = this.set_value_start();
        console.log(response);
        if (response == true) {
          clearInterval(interval);
        }
      }, 2000);
    } else {
      this.Cases = "Choose Your Options";
      let interval = setInterval(() => {
        let response = this.set_value_end();
        console.log(response);
        if (response == true) {
          clearInterval(interval);
        }
      }, 2000);
    }

  }

  set_value_start() {
    let startdate = localStorage.getItem("start");
    console.log(startdate);
    this.start_dt = startdate;
    return true;
  }

  set_value_end() {
    let enddate = localStorage.getItem("end");
    console.log(enddate);
    this.end_dt = enddate;
    return true;
  }

  onSubmit() {
    this.result_loader = true;
    let details = [];
    for (let index = 0; index < this.selectedItems_details_list.length; index++) {
      details.push(this.selectedItems_details_list[index]['itemName']);
    }
    // let treatments = [];
    // for (let index = 0; index < this.selectedItems_treatments_list.length; index++) {
    //   treatments.push(this.selectedItems_treatments_list[index]['itemName']);
    // }


    // let fulltreatment = DashboardComponent.Treatment.concat(","+this.Treatment);
    // console.log(fulltreatment);
    // let filterdata = this.Treatment.split(",");
    this.selectedItems_treatments_list  = this.Treatment.split(",");
    console.log(this.selectedItems_treatments_list);
    
    let data = {};
    if (this.radio_Option === 'caseno') {
      data = {
        action: "search_portal_query",
        body_part: this.bodypart_name,
        decision: this.Decision,
        treatment: this.selectedItems_treatments_list,
        case_no: this.Cases,
        startdate: "",
        enddate: "",
        details_list: details
      }
    } else {
      data = {
        action: "search_portal_query",
        body_part: this.bodypart_name,
        decision: this.Decision,
        treatment: this.selectedItems_treatments_list,
        case_no: 0,
        startdate: localStorage.getItem("start"),
        enddate: localStorage.getItem("end"),
        details_list: details
      }
    }
    console.log(data);

    this.apirequest.customize_flow(data).subscribe(res => {
      console.log(res);
      if (res.status == "True") {
        localStorage.setItem("Result_data", JSON.stringify(res.msg));
        this.result_loader = false;
        this.Reset();
        this.router.navigate(['/user/query/result']);
      } else {
        this.msg_view(res.msg);
        this.result_loader = false;
      }
    });
  }

  Reset() {

    this.Treatment = '';
    DashboardComponent.Treatment = undefined;
    this.list_data = undefined;
    this.body_parts = undefined;
    this.details_list = [];
    this.treatments_list = [];
    this.DecisionList = ['uphold', 'overturn', 'all'];


    this.Decision = "Choose Your Option";
    this.bodypart_name = "";

    this.selectedItems_details_list = [];
    this.dropdownSettings_details_list = {};

    this.selectedItems_treatments_list = [];
    this.dropdownSettings_treatments_list = {};


    this.start_dt = "Choose Your Option";
    this.end_dt = "Choose Your Option";

    this.radiolabel = true;
    this.radio_Option = 'caseno';

    $('#end1').val('');
    $('#start1').val('');

    localStorage.setItem('start', '');
    localStorage.setItem('end', '');


    this.Cases = "Choose Your Option";
    this.dropdownSettings_treatments_list = {
      singleSelection: false,
      text: "Select Details List",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      limitSelection: 8,
      classes: "multi-select",
    };
    this.dropdownSettings_details_list = {
      singleSelection: false,
      text: "Select Details List",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: false,
      classes: "multi-select",
    };
    this.get_list();
  }

}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/dashboard/dashboard.component.ts